import { ApiService } from '../base'
import { GroupDTO, NewHireWaitingPeriodChoices } from '../../../interfaces'
import { SummaryData } from '../../../interfaces/employer-broker-shared/summary'

const getBrokerFullName = (r: GroupDTO) => {
  const producerName = r.agency?.producer_name
  if (!producerName || producerName.first_name) {
    return ''
  }
  return `${producerName.first_name} ${producerName.last_name}`
}

const mapSummaryData = (r: GroupDTO): SummaryData => ({
  companyName: r.group_name,
  groupID: r.group_id,
  coverageStart: r.coverage_effective_date || r.group_effective_date,
  coverageEnd: r.group_termination_date,
  generalAgency: r.agency?.agency_name,
  brokers: getBrokerFullName(r),
  totalMembers: r.total_members,
  currentBalanceDue: r.current_balance_due,
  currentBalanceDueDate: r.current_balance_due_date,
  employeeCount: r.employee_count || 0,
  onboardingStatus: r.onboarding_status,
  inRenewal: r.in_renewal,
  newHireWaitingPeriod:
    NewHireWaitingPeriodChoices[r.new_hire_waiting_period_update]
})

export class SummaryService extends ApiService {
  async getSummary(groupId?: string): Promise<SummaryData> {
    const url = groupId ? `/groups/${groupId}` : '/group'
    return this.request({
      method: 'get',
      url,
      credentials: true
    }).then((r: GroupDTO) => mapSummaryData(r))
  }

  async getGroup(groupId?: string): Promise<SummaryData> {
    const url = groupId ? `/groups/${groupId}` : '/group'
    return this.request({
      method: 'get',
      url,
      credentials: true
    })
  }
}
